import * as SwitchPrimitives from "@radix-ui/react-switch";
import { Check } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils/cn";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    data-slot="switch"
    className={cn(
      "peer relative inline-flex h-[26px] w-12 shrink-0 cursor-pointer items-center rounded-full border transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 p-[3px]",
      "bg-neutral-200 border-neutral-300 dark:bg-neutral-800 dark:border-border",
      "data-[state=checked]:bg-primary data-[state=checked]:border-primary",
      "hover:bg-neutral-300 hover:border-neutral-400 dark:hover:bg-neutral-700 dark:hover:border-neutral-500",
      "data-[state=checked]:hover:bg-primary data-[state=checked]:hover:border-primary",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none flex items-center justify-center h-[16px] w-[16px] rounded-full shadow-lg ring-0 transition-all",
        "bg-neutral-50",
        "data-[state=checked]:translate-x-[22px]",
        "data-[state=unchecked]:translate-x-0"
      )}
    >
      {props.checked && (
        <Check size={12} className="text-primary" strokeWidth={3} />
      )}
    </SwitchPrimitives.Thumb>
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };